import {
        REGISTRO_EXITOSO,
        REGISTRO_ERROR,
        OBTENER_USUARIO,
        LOGIN_EXITOSO,
        LOGIN_ERROR,
        CERRAR_SESION
} from '../../types';

export default (state,action) => {
    switch (action.type) {
        case REGISTRO_EXITOSO:
        case LOGIN_EXITOSO:
            localStorage.setItem('token', action.payload.token);
            return{
                ...state,
                autenticado: true,
                mensaje: null,
                cargando:false
            }
        case OBTENER_USUARIO:
            return {
                ...state,
                autenticado: true,
                usuario:action.payload,
                cargando:false
            }
        case LOGIN_ERROR://toma el mismo de abajo
        case REGISTRO_ERROR:
        case CERRAR_SESION:
            localStorage.removeItem('token');
            return{
                ...state,
                token: null,
                mensaje: action.payload,
                usuario:null,
                autenticado:false,
                cargando:false
            }   
    
        default:
            return state;
    }
}
 